import { Commodity } from "features/shared/enums/commodity";
import { FormValidations, SetValidationRuleFunction, ValidationActionType } from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";
import ValidationService from "features/validation/ValidationService";

export const placeOfDeliveryFormValidations = (
  commodity: Commodity
): FormValidations => {
  const basicValidations = getBasicValidations();
  let commodityValidations: FormValidations = {};

  switch (commodity) {
    case "Electricity":
      commodityValidations = getElectricityValidations()
      break;
    case "Gas":
      commodityValidations = getGasValidations();
      break;
    default:
      break;
  }

  return {
    ...basicValidations,
    ...commodityValidations,
  };
};

export const setYearlyConsumptionNTValidation = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  setValidationRule(
    "yearlyConsumptionNT",
    getYearlyConsumptionRule(),
    action
  );
};

// PRIVATE
const getBasicValidations = (): FormValidations => {
  return {
    yearlyConsumption: getYearlyConsumptionRule(),
  };
};

const getGasValidations = (): FormValidations => {
  return {
    placeOfDeliveryIdentification: {
      required: true,
      type: "Function",
      validate: validateEic,
      message: "invalidEic",
    } as FunctionValidationRule,
    consumptionCharacteristics: {
      required: true,
      type: "OnlyRequired",
    }
  };
};

const getElectricityValidations = (): FormValidations => {
  return {
    placeOfDeliveryIdentification: {
      required: true,
      type: "Function",
      validate: validateEan,
      message: "invalidEan",
    } as FunctionValidationRule,
    distributionRate: {
      required: true,
      type: "OnlyRequired",
    },
    phase: {
      required: true,
      type: "OnlyRequired",
    },
    circuitBreaker: {
      required: true,
      type: "Function",
      validate: validateCircuitBreaker,
      message: "invalidTwoDecimalsNumber"
    } as FunctionValidationRule
  };
};

const getYearlyConsumptionRule = (): FunctionValidationRule => { 
  return {
    required: true,
    type: "Function",
    validate: validateYearlyConsumption,
    message: "invalidThreeDecimalsNumber"
  }
}

const validateYearlyConsumption = (value: number) => { 
  const validationService = new ValidationService();
  const regex: RegExp = /^(\d+(?:[\.\,]\d{1,3})?)$/;

  return validationService.validateRegex(String(value), regex);
}

const validateCircuitBreaker = (value: number) => { 
  const validationService = new ValidationService();
  const regex: RegExp =/^(\d+(?:[\.\,]\d{1,2})?)$/;

  return validationService.validateRegex(String(value), regex);
}

const validateEan = (value: string) => { 
  const validationService = new ValidationService();
  return validationService.validateEan(value);
}

const validateEic = (value: string) => { 
  const validationService = new ValidationService();
  return validationService.validateEic(value);
}